import React, { useState, useEffect } from "react";
import { Link, NavLink, withRouter } from "react-router-dom";
import useStore from "../../../context/useStore";
import { authActions } from "../../../context/actions/authActions";
import "./sidenav.scss";
import Avatar from "../Avatar";
import { push as Menu } from "react-burger-menu";
import { WEB_URL } from "../../../../src/config";
import useEspaceActif, { ESPACES } from "../../../hooks/useEspaceActif/useEspaceActif";
import SelecteurEspace from "./SelecteurEspace";

function debounce(fn, ms) {
  let timer;
  return (_) => {
    clearTimeout(timer);
    timer = setTimeout((_) => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

const Sidenav = withRouter(({ sidenavItems, sidenavOpen, setSidenavOpen }) => {
  const [state, dispatch] = useStore();
  const actions = authActions(state, dispatch);
  const { espace } = useEspaceActif();
  const itemsVisibles = sidenavItems.filter(
    (item) => !(item.entrepriseSeulement && espace === ESPACES.PARTICULIER)
  );
  const [avatarVisible, setAvatarVisible] = useState(true);
  const [showSub, setShowSub] = useState(false);
  const [dimensions, setDimensions] = useState({
    height: document.documentElement.clientHeight,
    width: document.documentElement.clientWidth,
  });
  const breakPoint = 769;

  useEffect(() => {
    if (state.auth.user.newImage) {
      setAvatarVisible(false);
      setTimeout(() => {
        setAvatarVisible(true);
        dispatch({
          type: "SET_CURRENT_USER",
          payload: { ...state.auth.user, newImage: false },
        });
      }, 200);
    }
  }, [state.auth]);

  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      if (Math.abs(1 - Math.abs(document.documentElement.clientWidth / dimensions.width)) > 0.04) {
        setDimensions({
          height: document.documentElement.clientHeight,
          width: document.documentElement.clientWidth,
        });
      }
    }, 500);

    window.addEventListener("resize", debouncedHandleResize);
    // window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
      // window.removeEventListener("scroll", handleScroll);
    };
  });

  // const handleScroll = (e) => {
  //   if (dimensions.width >= breakPoint) {
  //     var menu = document.querySelector(".bm-menu-wrap");

  //     // if (window.scrollY <= 64) {
  //     //   menu.style.top = 64 - window.scrollY + "px";
  //     // } else {
  //     //   menu.style.top = "0px";
  //     // }
  //   }
  // };

  useEffect(() => {
    var isOpen = false;
    if (dimensions.width >= breakPoint) {
      isOpen = true;
    } else {
      isOpen = false;
    }

    setSidenavOpen(isOpen);
    updateLayout(isOpen, true);
  }, [dimensions]);

  useEffect(() => {
    updateLayout(sidenavOpen);
  }, [sidenavOpen]);

  const updateLayout = (isOpen) => {
    var menuWrap = document.querySelector(".bm-menu-wrap");
    var mainContent = document.querySelector("#main-content");

    if (isOpen) {
      if (menuWrap) {
        menuWrap.classList.remove("minified");
      }
      mainContent.style.left = "0px";
      if (dimensions.width >= breakPoint) {
        mainContent.style.width = "calc(100% - 300px)";
      } else {
        mainContent.style.width = "100%";
      }
    } else {
      mainContent.style.width = "100%";
      if (dimensions.width >= breakPoint && menuWrap) {
        menuWrap.classList.add("minified");
        mainContent.style.width = "calc(100% - 75px)";
        mainContent.style.left = "75px";
      }
      if (dimensions.width < breakPoint && menuWrap) {
        menuWrap.classList.remove("minified");
        mainContent.style.left = "0px";
      }
    }

    if (state?.auth?.user?.mustRenewPassword) {
      mainContent.style.width = "100%";
    }
  };

  const closeOnMobile = () => {
    if (dimensions.width < breakPoint) {
      setSidenavOpen(false);
    }
  };

  // useEffect(() => {
  //   window.$("#sidebar").addClass("active");
  // }, [props.location.pathname]);
  var authData = state.auth;
  return authData.isAuthenticated && !authData.user.mustRenewPassword ? (
    <Menu
      disableCloseOnEsc
      isOpen={sidenavOpen}
      onOpen={() => setSidenavOpen(true)}
      onClose={() => setSidenavOpen(false)}
      noOverlay
      disableOverlayClick
      pageWrapId={"main-content"}
      outerContainerId={"outer-container"}
      customBurgerIcon={<i className="fa fa-bars text-white" />}
    >
      <div className="expand-btn" onClick={() => setSidenavOpen(true)}>
        <i className="fa fa-arrow-right" />
      </div>
      <div className="mb-3 sidenav-avatar d-block d-md-none">
        <NavLink to="/me" className="d-center flex-column" onClick={closeOnMobile}>
          {avatarVisible && <Avatar width={60} height={60} id={authData.user.id} />}
          <span className="text-white font-weight-bold mt-2">{authData.user.firstname}</span>
        </NavLink>
      </div>
      {/* Mobile : le sélecteur d'espace vit ici plutôt que dans le header (trop étroit) */}
      <div className="d-block d-md-none">
        <SelecteurEspace className="selecteur-espace-menu" onBascule={closeOnMobile} />
      </div>
      {itemsVisibles.map((m, mk) => (
        <NavLink
          className="nav-link d-flex align-items-center justify-content-between animated fadeInRight faster"
          to={m.path}
          onClick={closeOnMobile}
          data-priv={m.dataPriv}
          key={`navlink${m.path}`}
          style={{ animationDelay: `${(10 + mk) * 50}ms` }}
        >
          <div className="d-flex align-items-center">
            <div className="d-center" style={{ width: 40, height: 24 }}>
              <i className={`fa ic mr-3 fa-${m.icon}`} />
            </div>
            <span className="nav-item-text">{m.name}</span>
          </div>
          <i className="fa ic-arrow fa-chevron-right" />
        </NavLink>
      ))}

      <div
        className="text-center w-100 d-flex flex-column flex-fill justify-content-end pt-4 pb-3"
        style={{ transition: "300ms" }}
      >
        <div className=" stop-jittery">
          <a href={WEB_URL} target="_BLANK">
            <img
              src={`/images/logo${dimensions.width > breakPoint ? "-small" : "_white_nav"}.svg`}
              style={{ height: 45 }}
            />
          </a>
        </div>

        <div
          className={` mt-4 stop-jittery ${
            dimensions.width > breakPoint ? "text-success" : "text-white"
          } ${sidenavOpen ? "" : "d-none"}`}
        >
          <NavLink className="" to="/mentions-legales" onClick={closeOnMobile}>
            <small className="">Mentions Légales</small>
          </NavLink>
          <small className="px-1">|</small>
          <NavLink className="" to="/cgv" onClick={closeOnMobile}>
            <small className="">CGV</small>
          </NavLink>
          <small className="px-1">|</small>
          <small className="">© {new Date().getFullYear()}</small>
        </div>
      </div>
    </Menu>
  ) : (
    <></>
  );
});

export default withRouter(Sidenav);
